module.exports = __webpack_public_path__ + "img/icon_help_aluno.9cb741ba.svg";